import { defineMessages } from 'react-intl'

const messages = defineMessages({
  basqueCountry: {
    id: 'MenuOffCanvas.basqueCountry',
    description: '[Mantener HTML] Texto para la cabecera de País Vasco',
    defaultMessage: 'País <br/> Vasco'
  },
  youAreAt: {
    id: 'MenuOffCanvas.youAreAt',
    description: 'Texto para el MenuOffCanvas para indicar donde se encuentra el usuario',
    defaultMessage: 'Estás en'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/components/MenuOffCanvas/messages.js